export default __webpack_public_path__ + "static/media/women1.c10f280d.jpg";